var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeguridad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.625 21.5391C42.2603 21.5391 41.9106 21.6809 41.6527 21.9334C41.3948 22.1858 41.25 22.5283 41.25 22.8853V25.5777H33.5688L30.4218 22.4915L39.074 14.0188C39.5894 13.5139 39.8788 12.8293 39.8788 12.1155C39.8788 11.4018 39.5894 10.7172 39.074 10.2123L29.4489 0.788813C29.1936 0.538732 28.8904 0.340354 28.5567 0.205008C28.223 0.0696622 27.8653 0 27.5042 0C27.143 0 26.7853 0.0696622 26.4516 0.205008C26.1179 0.340354 25.8148 0.538732 25.5594 0.788813L0.501516 25.3994C0.261702 25.6349 0.0985469 25.9347 0.0326519 26.2609C-0.0332432 26.5872 0.0010771 26.9252 0.131279 27.2324C0.261481 27.5396 0.481726 27.8021 0.764203 27.9868C1.04668 28.1715 1.37872 28.2701 1.7184 28.2702H8.48518L14.5559 34.212C15.0715 34.7166 15.7707 35 16.4998 35C17.2288 35 17.928 34.7166 18.4437 34.212L28.4727 24.3998L31.6249 27.4809C31.8793 27.732 32.1822 27.9311 32.5159 28.0666C32.8497 28.2021 33.2076 28.2713 33.5688 28.2702H41.25V30.9626C41.25 31.3196 41.3948 31.6621 41.6527 31.9145C41.9106 32.167 42.2603 32.3088 42.625 32.3088C42.9897 32.3088 43.3394 32.167 43.5973 31.9145C43.8551 31.6621 44 31.3196 44 30.9626V22.8853C44 22.5283 43.8551 22.1858 43.5973 21.9334C43.3394 21.6809 42.9897 21.5391 42.625 21.5391ZM27.4999 2.69203L29.681 4.82747L8.48518 25.5777H4.20373L27.4999 2.69203ZM16.4998 32.3088L10.9997 26.9239L31.6249 6.73068L37.1249 12.1155L16.4998 32.3088Z",
    fill: "url(#paint0_linear_880_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_880_23",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273979"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguridad);
export default __webpack_public_path__ + "static/media/seguridad.c0873752c3c75c5ce6e1c09ed2913351.svg";
export { ForwardRef as ReactComponent };